import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class MetricsetModalService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    get(): Observable<any> {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET_COLLECTION);
        return this.ajaxService.getDataObserveBody(requestUrl);
    }

    post(urlParams: any, postParams: any): Observable<any> {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET_COLLECTION, urlParams);
        return this.ajaxService.postJsonDataObserveBody(requestUrl, postParams);
    }

    put(urlParams: any, putParams: any): Observable<any> {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET, urlParams);
        return this.ajaxService.putDataObserveBody(requestUrl, putParams);
    }

    delete(urlParams: any): Observable<any> {
        const requestUrl = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_SET, urlParams);
        return this.ajaxService.deleteDataObserveBody(requestUrl);
    }
}
